import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ZoomSliceType = {
  scale: number
  showFloatingZoomMenu: boolean
}

const INITIAL_STATE: ZoomSliceType = {
  scale: 1,
  showFloatingZoomMenu: false,
}

/**
 * 캔버스 휠, +/- 버튼, 셀렉트로 줌 sync를 맞추기위한 slice
 * */
export const zoomSlice = createSlice({
  name: 'zoom',
  initialState: INITIAL_STATE,
  reducers: {
    setZoomScale(state, action: PayloadAction<number>) {
      state.scale = action.payload
    },
    setShowFloatingZoomMenu(state, action: PayloadAction<boolean>) {
      state.showFloatingZoomMenu = action.payload
    },
    resetZoomState(state) {
      state.scale = 1
      state.showFloatingZoomMenu = false
    },
  },
})

export const { setZoomScale, setShowFloatingZoomMenu, resetZoomState } = zoomSlice.actions

export default zoomSlice.reducer
